module.exports = __webpack_public_path__ + "b5ee6381e724a2a9d08bc1b9db5e4c31.jpg";